import { Outlet } from "react-router";
import Navbar from "components/molecules/Navbar";

// Admin-specific layout (can have admin-specific sidebar items, styling, etc.)
export default function AdminLayout() {
  return (
    <div className="flex w-full h-screen flex-col items-start overflow-hidden">
      <Navbar />
      <div className="bg-white inline-flex justify-start items-start overflow-hidden flex-grow w-screen">
        
        <div className="flex flex-grow flex-col self-stretch p-7 bg-white max-h-screen overflow-y-auto [scrollbar-gutter:stable] ">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
